__turbopack_context__.v({
  "blurRowsAfterFour": "_5mj5_W_blurRowsAfterFour",
  "loaderContainer": "_5mj5_W_loaderContainer",
  "market-update-table": "_5mj5_W_market-update-table",
  "spin": "_5mj5_W_spin",
  "spinner": "_5mj5_W_spinner",
});
